import React from 'react'
import { IssuingSpendingProfileDlt } from './issuingSpendingProfileDlt'

export const IssuingSpendingProfileDelete = () => {
  return (
    <IssuingSpendingProfileDlt />
  )
}
